enum RouteStatus {
  Scheduled = 0,
  Started = 1,
  Finished = 2,
}

export default RouteStatus;
